import styled, { css } from 'styled-components';

import { primitive } from '../../designTokens/primitives';

export const FieldSetWrapper = styled.fieldset`
  border: none;
  padding: 0;
  margin: ${primitive.$spacing2} 0 ${primitive.$spacing6} 0;
`;

export const Legend = styled.legend<{ $hasError: boolean; $disabled: boolean | undefined }>`
  padding: 0;
  font: ${(p) => p.theme.token('text-style-form-legend')};
  color: ${(p) => p.theme.token('text-default')};
  margin-bottom: ${primitive.$spacing3};

  ${(p) =>
    p.$disabled &&
    css`
      color: ${p.theme.token('text-disabled')};
    `}

  ${(p) =>
    p.$hasError &&
    css`
      color: ${p.theme.token('text-error')};
    `}
`;

/** Negates the spacing added by form field bottom margin */
export const FieldSetMessage = styled.div`
  /* margin-top: -${primitive.$spacing4}; */
`;
